/**
 * Textos dos arquivos de fora (E146, GUS-179, ADR-0100). Linguagem simples, com a próxima ação.
 *
 * - `ptBRRecusa` (E146.F1, §2.6): o arquivo que o envio não recebeu, na tela de envio do portal e
 *   na linha da recusa no histórico do caso. A recusa não é achado e não diz nada sobre o conteúdo.
 * - `ptBRRecursos` (E146.F2, §2.7): o arquivo recebido com recursos automáticos, na lista de
 *   documentos. A marca diz o que a plataforma fez com eles; não é achado sobre o documento.
 */
export const ptBRRecusa = {
  naoRecebido: 'Não foi possível receber o arquivo.',
  tentarDeNovo: 'Tentar novamente',
  enviando: 'Enviando de novo…',
  motivo: {
    tipo: 'O arquivo não é PDF, Word (.docx) nem imagem JPG ou PNG. Envie em um desses formatos.',
    tamanho: 'O arquivo passa do limite do envio. Envie uma versão menor ou dividida.',
    vazio: 'O arquivo está vazio. Confira o arquivo e envie de novo.',
    ilegivel: 'O documento não abre. Envie de novo ou mande em PDF.',
    outro: 'Tente de novo. Se continuar, envie o arquivo em PDF.',
  },
} as const;

export const ptBRRecursos = {
  naoExecutados: 'Recursos automáticos do arquivo não foram executados: {{lista}}.',
  retirados: 'Retirados da cópia examinada: {{lista}}. O original fica guardado como chegou.',
  tipo: {
    javascript: 'código embutido',
    acao_automatica: 'ação automática',
    abertura_de_programa: 'abertura de programa',
    link_externo: 'endereço externo',
    envio_de_formulario: 'envio de formulário',
    arquivo_embutido: 'arquivo anexado',
    formulario_xfa: 'formulário dinâmico',
    macro: 'macro',
    vinculo_externo: 'vínculo externo',
    objeto_embutido: 'objeto embutido',
  },
} as const;
